import styled, { css } from 'styled-components';

var ndsBoxSizing = function ndsBoxSizing() {
  return css(["&,&::before,&::after,*,*::before,*::after{box-sizing:border-box;}"]);
};
/*
 * Mixin function to use when you need something to appear only to a screenreader, and not render visually.
 * @param {boolean} focusable - set to true if the element is able to take keyboard focus
 */

var ndsScreenReaderOnly = function ndsScreenReaderOnly(isFocusable) {
  return "\n  position: absolute;\n  display: inline-block;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  left: 0.1;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n\n  /* the focusable option, if set emits these pseudoclasses */\n  ".concat(isFocusable ? "\n    &:focus,\n    &:active {\n      position: static;\n      width: auto;\n      height: auto;\n      margin: 0;\n      overflow: visible;\n      clip: auto;\n    }" : '', "\n");
};
var ScreenReaderOnly = styled.span.withConfig({
  displayName: "utils__ScreenReaderOnly",
  componentId: "r7somp-0"
})(["", ""], function (props) {
  return ndsScreenReaderOnly(props.isFocusable);
});
var ScreenReaderOnlyImg = styled.img.withConfig({
  displayName: "utils__ScreenReaderOnlyImg",
  componentId: "r7somp-1"
})(["", ""], ndsScreenReaderOnly(false));

export { ndsBoxSizing, ndsScreenReaderOnly, ScreenReaderOnly, ScreenReaderOnlyImg };
